module.exports = __webpack_public_path__ + "static/media/Boost Logo.5f592dd4.svg";